export default __webpack_public_path__ + "static/media/mautic.fe0e43fd.svg";